import { ListConfigColumn } from "./types";

export const listDividerId = "listDivider";

export const listDividerSortableItem: ListConfigColumn = {
	id: listDividerId,
	name: listDividerId,
};
